import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { MessageSquare } from 'lucide-react';

const BoardBirimIletisim = () => {
  return (
    <div className="space-y-6" data-testid="board-birim-iletisim">
      <div>
        <h1 className="text-2xl font-bold text-[hsl(var(--foreground))]">
          İletişim
        </h1>
        <p className="text-[hsl(var(--muted-foreground))] mt-1">
          İletişim yönetimi
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-indigo-600" />
            İletişim Birimi
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-gray-500">
            <MessageSquare className="h-12 w-12 mx-auto mb-3 opacity-50" />
            <p className="text-lg font-medium">İçerik yakında eklenecek</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BoardBirimIletisim;
